import CryptoJS from 'crypto-js';

export default function decrypt(item) {
  try {
    var encrypted_json = JSON.parse(atob(item));
    const decryptedBytes = CryptoJS.AES.decrypt(
      encrypted_json.value,
      CryptoJS.enc.Base64.parse(getKey()),
      {
        iv: CryptoJS.enc.Base64.parse(encrypted_json.iv),
      },
    );

    return JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error('Decryption error:', error);
    return {
      content: '',
      status: '',
    }; // Return null or handle the error as needed
  }
}

function getKey() {
  var key = process.env.MIX_APP_KEY;
  // remove 7 first characters from the key
  key = key.substring(7);

  return key;
}
